import type { App } from 'vue'

export default {
  install(app: App): void {
    app.config.globalProperties.$config = {
      env: 'dev',
    }
  },
}
